import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Module-level constant — prevents a new array on every render of every consumer,
// which previously forced ReactMarkdown to re-create its plugin pipeline.
const REMARK_PLUGINS = [remarkGfm];

export default function Markdown({ children, className = "" }) {
  return (
    <div className={`tb-prose ${className}`}>
      <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{children || ""}</ReactMarkdown>
    </div>
  );
}
